export default __webpack_public_path__ + "static/media/icons8-phone.50869883.svg";